import React from "react";
import Navbar from "./components/Navbar";
import Searchbar from "./components/Searchbar";
import Showcontent from "./components/Showcontent";

function App() {
	const [searchOption, setSearchOption] = React.useState("Search for movies or tv series");
	const [searchCategory, setSearchCategory] = React.useState("home");
	const [searchItem, setSearchItem] = React.useState("");

	const setSearch = (searchItem) => {
		setSearchItem("");
		document.getElementById("search-bar").value = "";
		setSearchCategory(searchItem.toLowerCase());
		if (searchItem === "home") {
			setSearchOption("Search for movies or tv series");
		} else if (searchItem === "movies") {
			setSearchOption("Search for movies");
		} else {
			setSearchOption(`Search for ${searchItem}`);
		}
	};

	const searchWord = (word) => {
		setSearchItem(word);
	};

	return (
		<React.Fragment>
			<Navbar setSearch={setSearch} />

			<main>
				<Searchbar searchOption={searchOption} searchWord={searchWord} />
				<Showcontent searchCategory={searchCategory} searchItem={searchItem} />
			</main>
		</React.Fragment>
	);
}

export default App;
